import { ConfigProvider } from 'antd';
import { IntlProvider } from 'react-intl';
import React, { ReactElement } from 'react';
import { ANTD_LOCALE_MAP } from './constants';
import { useSessionStore } from '../../store/session';

interface Messages {
  [key: string]: Record<string, string>;
}

interface LanguageProviderProps {
  messages: Messages;
  children: ReactElement;
}

export const LanguageProvider: React.FC<LanguageProviderProps> = ({ messages, children }) => {
  const { locale } = useSessionStore();

  return (
    <IntlProvider
      key={locale}
      locale={locale}
      messages={messages[locale]}
      onError={
        import.meta.env.NODE_ENV === 'production'
          ? () => {}
          : (e: any) => {
              console.groupCollapsed(e.message);
              console.log(e);
              console.groupEnd();
            }
      }
    >
      <ConfigProvider locale={ANTD_LOCALE_MAP[locale]}>{React.Children.only(children)}</ConfigProvider>
    </IntlProvider>
  );
};
